<template>
  <section id="user-profile">
    <b-overlay
      :show="loading"
      no-center
      variant="transparent"
      rounded="sm"
    >
      <template #overlay>
        <loading-spinner />
      </template>
      <profile
        :user="user"
        :not-loaded="notLoaded"
        @setLoading="setLoading($event)"
        @setUser="setUser($event)"
        @getUser="getUser()"
        @getMe="getMe()"
      />
    </b-overlay>
  </section>
</template>

<script>
import { BOverlay } from 'bootstrap-vue'
// eslint-disable-next-line import/no-cycle
import useJwt from '@/auth/jwt/useJwt'
import { throwDefaultError } from '@/helpers/helpers'
// eslint-disable-next-line import/extensions
import Profile from '@/components/Profile'
import { logEvent } from 'firebase/analytics'

export default {
  components: {
    BOverlay,

    Profile,
  },
  data() {
    return {
      id: null,
      loading: false,
      notLoaded: false,
      user: null,
    }
  },
  computed: {
    storeUsers() {
      return this.$store.getters['users/users']
    },
  },
  watch: {
    $route: {
      handler(value) {
        if (this.id !== value.params.id) {
          this.id = value.params.id

          if (this.id) {
            this.getUser()
          }
        }
      },
      deep: true,
    },
    storeUsers: {
      handler(value) {
        if (this.user) {
          const storeUser = value.find(u => u.uuid === this.user.id)
          if (storeUser) {
            // eslint-disable-next-line no-param-reassign
            if (storeUser.status === 'USER_ONLINE') {
              // eslint-disable-next-line no-param-reassign
              this.user.profile.onlineStatus = 'online'
            } else if (storeUser.status === 'USER_OFFLINE') {
              // eslint-disable-next-line no-param-reassign
              this.user.profile.onlineStatus = 'offline'
            } else if (storeUser.status === 'USER_BUSY') {
              // eslint-disable-next-line no-param-reassign
              this.user.profile.busyInCall = true
            } else if (storeUser.status === 'USER_AVAILABLE') {
              // eslint-disable-next-line no-param-reassign
              this.user.profile.busyInCall = false
            }
            setTimeout(() => {
              this.$forceUpdate()
            }, 333)
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.id = this.$route.params.id

    if (this.id) {
      this.getUser()
    }

    // gtmTrackNewEvent('userdetail', {
    //   category: 'Avantajlar',
    //   action: 'UserDetail',
    //   label: this.id
    // })
  },
  methods: {
    getMe() {
      useJwt.getMe()
        .then(response => {
          this.$store.dispatch('auth/updateUser', response.data.body)
        })
    },
    getUser() {
      this.loading = true

      useJwt.getUser(this.id)
        .then(response => {
          try {
            this.user = response.data.body

            // Firebase Analytics Event
            if (window.firebaseAnalytics) {
              logEvent(window.firebaseAnalytics, 'user_engagement', this.user)
              logEvent(window.firebaseAnalytics, 'contact_information', this.user)
            }
          } catch (e) {
            throwDefaultError(this.$toast)
            this.notLoaded = true
          }
        })
        .catch(error => {
          throwDefaultError(this.$toast, error)
          this.notLoaded = true
        })
        .finally(() => {
          this.loading = false
        })
    },
    setLoading($event) {
      this.loading = $event
    },
    setUser($event) {
      this.user = $event
    },
  },
}
</script>
